<template>
  <div
    class="input-wrap input-textarea"
    :class="{ required: $attrs.required !== undefined }"
  > 
    <!--
      trigered on input change
      @event input      
    -->
    <textarea
      class="textarea"
      v-bind="$attrs"
      :id="id"
      :aria-required="$attrs.required !== undefined"
      :placeholder="placeholder"
      :value="value"
      @input="$emit('input', $event.target.value)"
      @on="$listeners"
    />
    <label :for="id">{{ placeholder }}</label>
  </div>
</template>
<script>
/**
 * Equivalent to the html ```<textarea>``` tag
 */
export default {
  name: "TextArea",
  inheritAttrs: false,
  props: {
    /**
     * Random id is generated if none provided
     */
    id: {
      type: String,
      default: () => `ta_${Math.random().toString(12).substring(2, 8)}`,
    },
    value: {
      type: [ String, Number ],
      default: "",
    },
    placeholder: {
      type: String,
      default: 'Insert label placeholder here',
    },
  },
};
</script>
<style lang="scss">
  // @import '../../../styles/inputs.scss';

  // textarea:focus::-webkit-input-placeholder {
  //   color: $dark-gray;
  // }

  // textarea:focus:-moz-placeholder {
  //   color: $dark-gray;
  // }
  // /* FF 4-18 */
  // textarea:focus::-moz-placeholder {
  //   color: $dark-gray;
  // }
  // /* FF 19+ */
  // textarea:focus:-ms-input-placeholder {
  //   color: $dark-gray;
  // }

  .input-textarea {
    position: relative;
    label {
      position: absolute;
      top: 1px;
      left: 13px;
      z-index: 5;
      font-size: 10px;
      color: $dark-gray;
      font-weight: 300;
      opacity: 0;
    }
    textarea{
      &:focus {
        border-width: 2px;
        // padding-bottom: 0;
        + label {
          opacity: 1;
        }
      }
    }
  }
</style>

